import { dayjs } from '@brands/ui/utils'

import { CALENDAR_PERIODS } from '../constants/employeePayHistory'

/**
 *
 * @param {Object} filter - employee filter
 * @param {String} filter.calendarPeriod - for example 'THIS_YEAR'
 * @param {String} filter.fromDate - for example '2019-01-01'
 * @param {String} filter.toDate - for example '2019-12-31'
 * @param {Number} filter.empnum - for example 12456
 * @param {Boolean} filter.isAllChecked
 * @param {String} filter.employeeFullName
 * @param {Date} date - current date, example 2019
 * @returns {*}
 */
export function updateFilterCalendarPeriods(filter, date) {
  const { fromDate, toDate, ...restFilter } = filter
  if (!filter.calendarPeriod) {
    return restFilter
  }
  if (filter.calendarPeriod === CALENDAR_PERIODS.CUSTOM.id && (!filter.fromDate || !filter.toDate)) {
    // Both fromDate and toDate should be set, otherwise we do not change dates
    return restFilter
  }
  let fromDateNew, toDateNew

  switch (filter.calendarPeriod) {
    case CALENDAR_PERIODS.THIS_YEAR.id: {
      fromDateNew = dayjs.utc(date).startOf('year').format('YYYY-MM-DD')
      toDateNew = dayjs.utc(date).endOf('year').format('YYYY-MM-DD')
      break
    }
    case CALENDAR_PERIODS.LAST_YEAR.id: {
      fromDateNew = dayjs.utc(date).startOf('year').subtract(1, 'year').format('YYYY-MM-DD')
      toDateNew = dayjs.utc(date).endOf('year').subtract(1, 'year').format('YYYY-MM-DD')
      break
    }
    case CALENDAR_PERIODS.THIS_QUARTER.id: {
      fromDateNew = dayjs.utc(date).startOf('quarter').format('YYYY-MM-DD')
      toDateNew = dayjs.utc(date).endOf('quarter').format('YYYY-MM-DD')
      break
    }
    case CALENDAR_PERIODS.LAST_QUARTER.id: {
      fromDateNew = dayjs.utc(date).startOf('quarter').subtract(1, 'quarter').format('YYYY-MM-DD')
      toDateNew = dayjs.utc(date).endOf('quarter').subtract(1, 'quarter').format('YYYY-MM-DD')
      break
    }
    default: {
      fromDateNew = fromDate
      toDateNew = toDate
    }
  }

  return {
    ...restFilter,
    fromDate: fromDateNew,
    toDate: toDateNew,
  }
}
